import * as React from 'react'
import { IResultsLoadedAction } from '../../actions/index'

export interface INoResultsProps {
    noResultsWYSIWYG: string;
}

export class NoResults extends React.Component<INoResultsProps, any> {

  render() {

    return (
        <div className="search-app-results-messaging">
            <div className="no-results-message" dangerouslySetInnerHTML={{ __html: this.props.noResultsWYSIWYG }} />
      </div>
    );
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/components/search-results/no-results.tsx